export const getMaskedCardNumber = number => {
    const last4digits = number.slice(-4);

    return last4digits.padStart(19, '**** ');
};
